import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { Seo } from "../components/Seo";
import { AuthShell, GoogleButton } from "./Login";

export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters."); return; }
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Account created — welcome!");
      navigate("/calculator");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not create account.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Seo title="Create account" path="/signup" description="Create a free Framer's Bench account to start calculating frame and mat sizes." />
      <AuthShell title="Create your account" subtitle="For artists who don't have time for maths - but can't afford mistakes. 7 days free, no card needed.">
        <GoogleButton label="Sign up with Google" />
        <div className="my-4 flex items-center gap-3 text-xs text-muted-foreground">
          <div className="h-px flex-1 bg-border" /> or <div className="h-px flex-1 bg-border" />
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="name">Name</Label>
            <Input id="name" value={name} onChange={(e) => setName(e.target.value)} data-testid="signup-name" className="mt-1.5" placeholder="Your name" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="signup-email" className="mt-1.5" placeholder="you@studio.com" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="signup-password" className="mt-1.5" placeholder="At least 6 characters" />
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="signup-submit">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Create account
          </Button>
        </form>
        <p className="mt-5 text-center text-sm text-muted-foreground">
          Already have an account? <Link to="/login" className="font-semibold text-primary hover:underline" data-testid="link-login">Log in</Link>
        </p>
      </AuthShell>
    </>
  );
}
